import { v4 as uuid } from "uuid";
import {Model} from "../base/Model";
import {Collection} from "../base/Collection";
import { MapModel } from "./Dropbox/Map";

export class DropboxModel extends Model  {
    maps: Collection = new Collection();
    state: number;
    
    constructor(data = null) {
        super();
        
        if(data) {
            this.createModel(data, {maps: MapModel, settings: Model});
        }
    }
    
}